import React from "react";
//#region types
import { DateConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { SalaryDeviationAndTimeReportTopTodoCardProps } from "models/propTypes/timeReportingPropTypes";
//endregion
//#region components
import TopTodoCard from "../topTodoCard";
import { Skeleton } from "@mui/material";
import { useSalaryDeviationsService } from "serviceHooks";
//endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const SalaryDeviationAndTimeLogReportTopTodoCard: React.FC<SalaryDeviationAndTimeReportTopTodoCardProps> = (props) => {
  const salaryDeviationsService = useSalaryDeviationsService();
  const { onViewInfoClick, item, report, noOfReportsToApprove } = props;
  return (
    <TopTodoCard
      item={item}
      descriptionHeadingOne={LocalizationHelperInstance.getFormattedDate(
        DateHelper.getDateFromYearMonth(report!.yearAndMonth),
        DateConstants.MonthLongConfig
      )}
      descriptionHeadingTwo={
        noOfReportsToApprove === undefined ? (
          <Skeleton variant="rectangular" width={100} height={8} />
        ) : (
          `${noOfReportsToApprove.toString()} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Pc
          )}`
        )
      }
      footerText={`${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Common.Due_Date
      )}: ${LocalizationHelperInstance.getFormattedDate(
        salaryDeviationsService.getDueDateForTimeLog(report!.yearAndMonth)
      )}`}
      onViewAllClick={onViewInfoClick}
    />
  );
};

export default SalaryDeviationAndTimeLogReportTopTodoCard;
